var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancingicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 168,
    viewBox: "0 0 193 168",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#financingicon_svg__clip0_750_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.321 131.413l9.823-112.28-82.091-7.182-9.823 112.28 82.091 7.182z",
    fill: "#fff",
    stroke: "#02385C",
    strokeWidth: 4.364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.169 101.59c5.774.505 10.863-3.755 11.367-9.517.504-5.76-3.768-10.84-9.542-11.346-5.774-.505-10.864 3.756-11.368 9.517-.504 5.761 3.769 10.841 9.543 11.346zm.295-3.379c3.904.341 7.345-2.539 7.685-6.434.341-3.895-2.547-7.329-6.451-7.67-3.903-.342-7.344 2.538-7.685 6.433-.341 3.895 2.548 7.33 6.451 7.671z",
    fill: "#9AAFBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.994 80.727c-5.774-.505-10.864 3.767-11.37 9.541a10.496 10.496 0 005.052 9.915l1.75-2.915a7.095 7.095 0 01-3.415-6.703 7.095 7.095 0 017.686-6.45l.297-3.388z",
    fill: "#02385C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.225 139.454L161.287 3l-99.903 8.74 11.939 136.454 99.902-8.74z",
    fill: "#fff",
    stroke: "#02385C",
    strokeWidth: 4.364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.727 80.989c6.63-.58 11.535-6.413 10.956-13.028-.578-6.614-6.422-11.506-13.051-10.926-6.63.58-11.535 6.412-10.956 13.027.578 6.615 6.422 11.507 13.051 10.927zm-.34-3.88c4.483-.392 7.799-4.335 7.407-8.807-.39-4.472-4.341-7.78-8.823-7.387-4.482.392-7.798 4.335-7.407 8.807s4.342 7.779 8.824 7.387z",
    fill: "#9AAFBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.632 57.035c-6.63.58-11.534 6.425-10.954 13.055a12.051 12.051 0 007.689 10.204l1.398-3.646a8.147 8.147 0 012.207-15.724l-.34-3.89z",
    fill: "#BDE5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.963 93.29l-44.122 3.86a1.565 1.565 0 00.273 3.118l44.122-3.86a1.565 1.565 0 10-.273-3.119zM129.157 102.442l-28.633 2.505a1.565 1.565 0 10.273 3.118l28.633-2.505a1.565 1.565 0 10-.273-3.118z",
    fill: "#003862"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "financingicon_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 20,
    width: 71,
    height: 67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.677 20.122l-64.278 5.623 5.326 60.88L144.003 81l-5.326-60.88z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#financingicon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.758 20.29l-60.44 5.287a1.927 1.927 0 00.336 3.839l60.44-5.288a1.926 1.926 0 10-.336-3.839z",
    fill: "#003862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.667 72.761c1.218-.106 2.259-.45 3.123-1.032.882-.603 1.54-1.43 1.973-2.48l3.971-.347c-.584 1.998-1.662 3.591-3.232 4.78-1.571 1.189-3.429 1.877-5.573 2.065-2.261.198-4.324-.235-6.189-1.299-1.867-1.082-3.238-2.618-4.112-4.605l-2.667.233-.198-2.26 2.145-.188a18.95 18.95 0 01-.169-1.27c-.027-.31-.045-.737-.054-1.281l-2.145.188-.198-2.261 2.667-.233c.516-2.11 1.601-3.85 3.252-5.221 1.651-1.39 3.606-2.185 5.867-2.383 2.126-.186 4.066.18 5.821 1.098 1.772.896 3.12 2.277 4.042 4.144l-3.971.347c-.609-.959-1.4-1.65-2.371-2.07-.954-.443-2.04-.61-3.257-.504-1.411.123-2.628.56-3.653 1.313-1.005.75-1.737 1.738-2.194 2.966l6.174-.54.198 2.26-6.812.597c-.022.41-.014.838.025 1.283.039.444.105.867.198 1.267l6.812-.595.198 2.26-6.174.54c.665 1.15 1.558 2.006 2.678 2.57 1.14.562 2.415.782 3.825.659z",
    fill: "#02385C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.325 138.653h-39.28v10.182h39.28v-10.182zM77.597 128.471h-39.28v10.182h39.28v-10.182z",
    fill: "#fff",
    stroke: "#02385C",
    strokeWidth: 4.364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.325 118.29h-39.28v10.182h39.28V118.29zM86.325 97.927h-39.28v10.181h39.28V97.927zM77.597 108.108h-39.28v10.181h39.28v-10.181z",
    fill: "#fff",
    stroke: "#02385C",
    strokeWidth: 4.364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.884 143.178l45.014 4.551a11.646 11.646 0 005.072-.615l21.352-7.598 2.481 7.892c.2.635-.057 1.324-.623 1.674l-26.794 16.561h-34.62l-7.425-4.146-4.457-18.319z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.486 143.34l43.621 2.839a11.645 11.645 0 003.96-.425l24.028-6.883a7.917 7.917 0 01-1.023 13.285l-21.594 11.627a2.912 2.912 0 01-1.38.347H28.662l-8.197-3.837-3.978-16.953z",
    stroke: "#02385C",
    strokeWidth: 4.364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.258 148.092s7.022.52 11.329.956l13.24 1.561.781-3.237c1.293-5.356-1.39-10.667-5.994-11.862l-21.882-3.847-13.606 4.855-4.385 12.157",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.702 146.31s6.991.646 11.281 1.148l13.196 1.738.694-2.886c1.148-4.774-1.654-9.61-6.26-10.801l-21.84-4.01-13.395 4.01-4.047 10.801",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.702 146.31s6.991.646 11.281 1.148l13.196 1.738.694-2.886c1.148-4.774-1.654-9.61-6.26-10.801l-21.84-4.01-13.395 4.01-4.047 10.801",
    stroke: "#02385C",
    strokeWidth: 4.364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 131.331h17.655v34.312H3v-34.312z",
    fill: "#9AAFBE",
    stroke: "#02385C",
    strokeWidth: 4.364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "financingicon_svg__clip0_750_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h193v168H0z"
  })))));
}
export default SvgFinancingicon;